// Real data for Tullaghan Pod - Client Site
// Updated with Caroline & Joe's actual information

export const bookingData = {
  // Variable pricing based on day of week
  pricing: {
    thursday: 149,
    friday: 159,
    saturday: 159,
    sunday: 149,
    // Closed Monday, Tuesday, Wednesday
  },
  pricePerNight: 149, // Base display price (Thursday rate)
  cleaningFee: 0, // No cleaning fee
  serviceFee: 0, // Can be added later if needed
  minNights: 1, // Minimum 1 night
  maxNights: 2, // Maximum 2 nights
  maxGuests: 2,
  checkInTime: "3:00 PM",
  checkOutTime: "11:00 AM",
  deposit: {
    amount: 50,
    perPerson: true,
    refundable: true,
    timing: "48 hours before arrival",
    returnPolicy: "fully returned after your stay once everything is in order",
    paymentMethods: "Revolut or a secure online payment link"
  },
  // Example booked dates
  bookedDates: [
    '2026-02-14',
    '2026-02-15',
    '2026-02-28',
    '2026-03-01',
    '2026-03-14',
    '2026-03-15',
  ]
};

export const propertyInfo = {
  name: "The Tullaghan Pod",
  tagline: "A Cosy Glampsite on the Wild Atlantic Way",
  location: "Tullaghan, County Leitrim, Ireland",
  description: "Set close to the rugged coastline of County Leitrim, this peaceful hideaway offers open views towards the North Atlantic Ocean and a sense of true privacy. A cosy double bed takes centre stage, which makes slow mornings and restful nights effortless. In addition, electric heating, Wi-Fi, smart TV, fresh bed linen, soft towels and robes ensure guests feel instantly at home from arrival. The open-plan kitchenette keeps things simple yet practical. A separate private bathroom adds extra convenience. It includes an electric shower, wash hand basin, toilet, and a backlit mirror for a touch of comfort. Self check-in allows complete flexibility, while free on-site parking removes any travel worries. For added indulgence, the covered wood-fired hot tub offers a standout experience and a fire pit is available to guests upon request. Evenings spent soaking under the sky feel especially memorable, with ocean views completing the scene.",
  hostStory: "We are Caroline and Joe, the hosts of The Tullaghan Pod, a cosy glampsite tucked away on the Leitrim stretch of the Wild Atlantic Way. We opened our glamping pod in 2024, welcoming our first guests that autumn. Our ethos is simple: calm, privacy and a warm Irish welcome, with space for guests to slow down, breathe in the sea air, and truly switch off from everyday life.",
  highlights: [
    "Covered wood-fired hot tub with ocean views",
    "Open views towards the North Atlantic Ocean",
    "Self check-in with complete flexibility",
    "Located in a peaceful residential area",
    "Maximum 2-night stays"
  ]
};

export const amenities = [
  // Comfort & Sleep
  { icon: "Bed", name: "Cosy Double Bed", description: "Premium bed linen, extra pillows and blankets" },
  { icon: "Wind", name: "Climate Control", description: "Electric heating for year-round comfort" },
  { icon: "Shirt", name: "Soft Robes", description: "Fresh towels and bathrobes provided" },
  
  // Essentials
  { icon: "Wifi", name: "High-Speed WiFi", description: "Stay connected throughout your stay" },
  { icon: "Tv", name: "Smart TV", description: "Entertainment for cosy evenings" },
  { icon: "ParkingCircle", name: "Free Parking", description: "On-site parking included" },
  
  // Kitchen & Dining
  { icon: "Coffee", name: "Kitchenette", description: "Cooker, fridge, kettle, coffee machine" },
  { icon: "UtensilsCrossed", name: "Cooking Essentials", description: "Utensils, wine glasses, dining table" },
  
  // Bathroom
  { icon: "Bath", name: "Private Bathroom", description: "Electric shower, backlit mirror, toiletries" },
  { icon: "Sparkles", name: "Premium Toiletries", description: "Hairdryer and cleaning products provided" },
  
  // Outdoor Experience
  { icon: "Waves", name: "Wood-Fired Hot Tub", description: "Covered hot tub with ocean views" },
  { icon: "Flame", name: "Fire Pit", description: "Available upon request for evening ambiance" },
  { icon: "TreePine", name: "Garden & Picnic Area", description: "Outdoor seating and picnic bench" },
  
  // Convenience
  { icon: "KeyRound", name: "Self Check-In", description: "Lockbox entry from 3pm" },
  { icon: "Hanger", name: "Storage", description: "Hangers and storage space" },
];

export const localAttractions = [
  {
    name: "Tullaghan Beach",
    distance: "10 minute walk",
    description: "Coastal area with castle ruins, beautiful waves, and views of Sliabh Liag on the horizon. A peaceful spot to connect with the rugged Atlantic coastline",
    image: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/4vqks7bd_IMG_7875.jpeg"
  },
  {
    name: "Bundoran",
    distance: "5 minute drive",
    description: "Ireland's surf capital with traditional pubs, fresh seafood restaurants, amusement arcades, and vibrant coastal town atmosphere",
    image: "https://images.unsplash.com/photo-1606988781449-eabdcc78c23b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxCdW5kb3JhbiUyMElyZWxhbmQlMjBzdXJmJTIwdG93biUyMGJlYWNofGVufDB8fHx8MTc3NTE1NDA3M3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Rossnowlagh",
    distance: "20 minute drive",
    description: "Beautiful 3km Blue Flag beach with golden sand, gentle surf, peaceful atmosphere, and stunning views of Donegal Bay",
    image: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/3oydg50j_IMG_7873.jpeg"
  },
  {
    name: "Mullaghmore Head & Classiebawn Castle",
    distance: "25 minute drive",
    description: "Dramatic clifftop walks with breathtaking Atlantic views, historic castle ruins, and some of Ireland's most photographed coastal scenery",
    image: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/jnx5zrp6_IMG_7874.jpeg"
  },
  {
    name: "Sliabh Liag",
    distance: "1 hour drive",
    description: "Europe's highest sea cliffs with awe-inspiring views over the Atlantic. A must-visit natural wonder of County Donegal",
    image: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/hgmsd326_IMG_7876.jpeg"
  },
  {
    name: "Tullan Strand",
    distance: "10 minute drive",
    description: "One of Ireland's most consistent beach breaks for surfing. Perfect for lessons, catching waves, or a walk along the beach. Equipment rental and surf lessons available",
    image: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/ahtrvuto_IMG_7877.jpeg"
  }
];

export const gallery = [
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/z7zecblz_Exterior.jpeg",
    caption: "The Pod at Dusk",
    category: "exterior"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/vax28qy1_Hot%20tub.jpeg",
    caption: "Wood-Fired Hot Tub",
    category: "exterior"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/tg4hlv3b_Inside.jpeg",
    caption: "Cosy Interior",
    category: "interior"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/xs2q3wbf_Kitchen.jpeg",
    caption: "Kitchenette & Dining",
    category: "interior"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/jjv6p7ja_Bathroom.jpeg",
    caption: "Modern Bathroom",
    category: "interior"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/myvxw1h2_20260306_140234.jpeg",
    caption: "Garden & Outdoor Space",
    category: "exterior"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/burhg67e_Bundoran.jpeg",
    caption: "Coastal Sunset Views",
    category: "views"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/r4uyzazu_Sunset.jpeg",
    caption: "Coastal Views",
    category: "views"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Sarah & Tom",
    rating: 5,
    date: "February 2025",
    text: "Perfect romantic getaway. The hot tub under the stars was brilliant. Caroline and Joe were great hosts - very welcoming. Will definitely be back.",
    avatar: "S"
  },
  {
    id: 2,
    name: "Emma",
    rating: 5,
    date: "January 2025",
    text: "Peaceful escape from everyday life. The pod is lovely and spotlessly clean. Sea views and evenings in the hot tub were fantastic. Highly recommend.",
    avatar: "E"
  },
  {
    id: 3,
    name: "Airbnb Guest Favourite",
    rating: 5,
    date: "4.98 Rating",
    text: "One of Airbnb's most loved homes with over 150 five-star reviews. Caroline and Joe are Superhosts known for their warm hospitality and attention to guest experience.",
    avatar: "⭐"
  }
];

export const mockBookings = [
  {
    id: "BK001",
    guestName: "Sarah M.",
    email: "sarah.m@example.com",
    checkIn: "2026-02-14",
    checkOut: "2026-02-15",
    guests: 2,
    totalPrice: 155,
    status: "confirmed",
    paymentMethod: "stripe"
  },
  {
    id: "BK002",
    guestName: "Emma & David",
    email: "emma.d@example.com",
    checkIn: "2026-02-28",
    checkOut: "2026-03-01",
    guests: 2,
    totalPrice: 295,
    status: "confirmed",
    paymentMethod: "stripe"
  },
  {
    id: "BK003",
    guestName: "Michael R.",
    email: "michael.r@example.com",
    checkIn: "2026-03-14",
    checkOut: "2026-03-15",
    guests: 2,
    totalPrice: 140,
    status: "pending",
    paymentMethod: "stripe"
  }
];
